<template>
    <div
        class="mt-2"
        id="mainDetails"
        v-if="personId"
    >
        <v-flex
            lg4
            md6
            sm8
            v-cloak
            xs12
        >
            <v-toolbar
                class="elevation-1 white--text"
                color="primary"
                height="50px"
            >
                <v-toolbar-title>
                    <v-icon class="white--text">fa-info-circle</v-icon>
                    Summary
                </v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                />
                <v-spacer />
                <v-btn color="red darken-1" title="Send Details Confirmation email" 
                    @click="sendConfirmation"
                >
                    <v-icon class="white--text">fa-envelope</v-icon>
                </v-btn>
                <EditPersonSummaryDialog :person="person" />
            </v-toolbar>
            <v-card>
                <v-simple-table
                    class="table"
                    id="mainDetailTable"
                >
                    <tbody>
                    <tr>
                        <td>
                            <div class="py-3">Name</div>
                        </td>
                        <td>{{ person.name }}</td>
                    </tr>
                    <tr>
                        <td>
                            <div class="py-3">Date of birth</div>
                        </td>
                        <td>{{ person.dateOfBirth | formatDate }}</td>
                    </tr>
                    <tr>
                        <td>
                            <div class="py-3">Home Country</div>
                        </td>
                        <td>{{ getCountryNameById(person.homeCountryId) }}</td>
                    </tr>
                    <tr>
                        <td>
                            <div class="py-3">Work Email</div>
                        </td>
                        <td>{{ person.emailAddressWork }}</td>
                    </tr>
                    <tr>
                        <td>
                            <div class="py-3">Manager</div>
                        </td>
                        <td>{{ getPersonNameById(person.managerId) }}</td>
                    </tr>
                    <tr>
                        <td>
                            <div class="py-3">REVUE Api Key</div>
                        </td>
                        <td>{{ person.revueApiKey }}</td>
                    </tr>
                    <tr>
                        <td>
                            <div class="py-3">Azure AD Object Id</div>
                        </td>
                        <td>{{ person.azureAdObjectId }}</td>
                    </tr>
                    <tr>
                        <td>
                            <div class="py-3">Live</div>
                        </td>
                        <td>{{ person.isLive == 1 ? 'Yes' : 'No' }}</td>
                    </tr>
                    </tbody>
                </v-simple-table>
            </v-card>
        </v-flex>
    </div>
    <div v-else>
        Person not retrieved from database
    </div>
</template>

<script>
import { FETCH_COUNTRY_LIST } from "@/store/country/actions";
import { FETCH_PERSON, SEND_DETAILS_CONFIRMATION } from "@/store/person/actions";
import { FETCH_TEAM_LIST } from "@/store/team/actions";
import { mapGetters } from "vuex";
import EditPersonSummaryDialog from "./EditPersonSummaryDialog";

    export default {
        name: "PersonSummary",
        components: {
            EditPersonSummaryDialog,
        },

        props: {
            personId: {
                type: Number,
                required: true,
            },
        },

        data: function () {
            return {
                namespace: "personPersonSummarys",
            };
        },

        computed: {
            ...mapGetters(
            [
                "person",
                "countryList",
                "ecsCompanyList",
                "jobList",
                "teamList",
                "getCountryNameById",
                "getPersonNameById",
                "getTeamNameById",
            ]
            )
        },

        mounted() {
            if (this.personId) {
                // this.fetchPersonnel();
                // this.fetchPerson();
                this.fetchCountryList();
                // this.fetchTeamList();
            }
        },

        methods: {
            // fetchPersonnel() {
            //     this.$store.dispatch(FETCH_PERSONNEL);
            // },
            fetchPerson() {
                this.$store.dispatch(FETCH_PERSON, this.personId);
            },
            fetchCountryList() {
                this.$store.dispatch(FETCH_COUNTRY_LIST);
            },
            fetchTeamList() {
                this.$store.dispatch(FETCH_TEAM_LIST);
            },
            sendConfirmation() {
                confirm(`Are you sure you want to send details confirmation email to ${this.person.name}?`) && this.$store.dispatch(SEND_DETAILS_CONFIRMATION, this.personId);
            }
        }

    }
</script>

<style scoped>
    #mainDetailTable {
        width: 100%;
        text-align: left;
    }

    #mainDetailTable th,
    #mainDetailTable td {
        text-align: left;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    /*// Small devices (landscape phones, 576px and up)*/
    @media (max-width: 576px) {
        .container {
            padding: 0;
            margin: 0;
        }

        body {
            padding: 0;
        }

        #mainDetails {
            padding: 0 !important;
        }

    }
</style>
